var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rich-text-editor-wapper"},[_c('div',{ref:"toolbar",staticClass:"tool-bar"}),_c('div',{ref:"containner",staticClass:"containner"})])
}
var staticRenderFns = []

export { render, staticRenderFns }